export default __webpack_public_path__ + "static/media/candidate.e6327db5.svg";